class EventListenersStore {
  constructor(parentStoreGetter, listeners = /* @__PURE__ */ new Map()) {
    this.parentStoreGetter = parentStoreGetter;
    this.listeners = listeners;
  }
  set(event, listeners) {
    this.listeners.set(this.formatMapEntryKey(event), listeners);
  }
  delete(event) {
    this.listeners.delete(this.formatMapEntryKey(event));
  }
  deleteByType(type) {
    const prefix = this.formatMapEntryKey({ type, key: "" });
    for (const eventType of this.listeners.keys()) {
      if (eventType.startsWith(prefix)) {
        this.listeners.delete(eventType);
      }
    }
  }
  get(event) {
    const ownListeners = this.listeners.get(this.formatMapEntryKey(event));
    const parentListeners = this.parentStoreGetter?.()?.get(event);
    if (!parentListeners) {
      return ownListeners;
    } else if (!ownListeners) {
      return parentListeners;
    }
    return /* @__PURE__ */ new Set([...ownListeners, ...parentListeners]);
  }
  add(event, handler) {
    const key = this.formatMapEntryKey(event);
    let eventListeners = this.addInternal(key, handler);
    return () => eventListeners?.delete(handler);
  }
  cloneDeep() {
    const store = new EventListenersStore();
    for (const [key, value] of this.listeners.entries()) {
      store.listeners.set(key, new Set(value));
    }
    return store;
  }
  clone() {
    const store = new EventListenersStore();
    store.listeners = new Map(this.listeners);
    return store;
  }
  append(other) {
    for (const [eventKey, otherListeners] of other.listeners) {
      for (const listener of otherListeners) {
        this.addInternal(eventKey, listener);
      }
    }
  }
  formatMapEntryKey(event) {
    return event.key ? `${event.type}_${event.key ?? ""}` : event.type;
  }
  addInternal(key, handler) {
    let eventListeners = this.listeners.get(key);
    if (!eventListeners) {
      eventListeners = /* @__PURE__ */ new Set();
      this.listeners.set(key, eventListeners);
    }
    eventListeners.add(handler);
    return eventListeners;
  }
}
export {
  EventListenersStore
};
//# sourceMappingURL=EventListenersStore.js.map
